module.exports = __webpack_public_path__ + "static/media/1_pl.d3718bec.png";